(ns web3.queries.root
  (:require [x-vec.graphql :as x]
            [web3.persistence.queries :as q]
            [web3.queries.asset :as q-asset]
            [web3.queries.profile :as q-profile]))

(declare fragment query mutation
         UUID! ID! String StreetAddressInput! String! SearchInputType!
         root-query-fields)

(x/def ^fragment sponsor-fields {:on :Sponsor}
  q/entity-id-fields
  :uuid
  :personName
  :companyName
  :mobilePhone
  :officePhone
  :email
  [:personImage (q/thumbnail-link)]
  [:companyImage (q/thumbnail-link)]
  :companyWebsite)

(x/def ^fragment property-fields {:on :Property}
  q/entity-id-fields
  :nickname
  [:address q-profile/address-fields]
  [:sponsors sponsor-fields]
  [:propertyTransferRequest
   q/entity-id-fields
   :email
   :firstName
   :lastName])

;; User

(x/def ^fragment root-query-fields {:on :User}
  q/entity-id-fields
  q-profile/profile-fields
  :email
  :proPlan
  [:signUps
   q/entity-id-fields
   :createdAt
   :refereeEmail
   :referralAssetCount
   :referralPropertyCount]
  [:propertyTransferViews
   q/entity-id-fields
   [:address q-profile/address-fields]
   :createdAt
   :acceptedDate
   :recipientFirstName
   :recipientLastName
   :recipientEmail]
  q-profile/referral-link-fields
  [:propertyRights
   q/entity-id-fields
   [:property
    :createdAt
    property-fields
    [:assetGroups
     q-asset/asset-group-name-fields
     q-asset/asset-group-alert-fields]]])

(x/defn ^query me []
  [:me root-query-fields])

(x/defn ^query search [{:keys [^String! term
                               ^SearchInputType! type]}]
  [:search {:term term
            :types [type]}
   [:... {:on :SearchResult}
    :value
    [:entity q/entity-id-fields
     [:... {:on :Tag}
      :transcriptionAvailable]]]])

(x/defn ^query tag [{:keys [^UUID! id]}]
  [:entity {:gql/alias-of :lookupEntity
            :typeName "Tag"
            :uuid id}
   [:... {:on :Tag}
    q/entity-id-fields
    :name]])

(x/defn ^query zip-lookup [{:keys [^String! zipcode]}]
  [:lookupZipcode {:zipcode zipcode}
   [:... {:on :LookupZipcodeResult}
    :city
    :state]])

(defn fetch-tag
  "Looks up tag by tagName"
  [tag-name]
  (let [first-result (-> (search {:term tag-name
                                  :type "Tag"}
                                 {:debounce-ms 1000})
                         :search
                         first)]
    (when (= (:value first-result)
             tag-name)
      first-result)))